// A WhatsApp Business label row — the one shape both engines emit for the
// labels reads (waGetLabelsTool, waGetChatLabelsTool).

import { z } from 'zod';

export const BtSlimLabelSchema = z.object({
  labelId: z.string(),
  /** The label's name; an engine fills '' when WhatsApp carries none. */
  name: z.string(),
  /** WhatsApp's label palette index; an engine fills 0 when WhatsApp carries none. */
  colorIndex: z.number().int(),
  /** The palette colour as `#rrggbb`, when the engine knows it (WAWeb does; Baileys carries only the index). */
  hexColor: z.string().optional(),
});
export type BtSlimLabel = z.infer<typeof BtSlimLabelSchema>;
